module.exports = __webpack_public_path__ + "img/mda.f3814561.svg";